import { FC } from 'react';

import { SurveyLanguage } from '@/graphql/generated';

import LanguageDropdown from '@/components/form/LanguageDropdown';
import { XIcon } from '@/components/icons';

type FormHeaderProps = {
  initialData: boolean;
  currentLanguage: SurveyLanguage;
  pickLanguage: (language: SurveyLanguage) => void;
  onClose: () => void;
  t: (key: string, options?: any) => string;
};

export const FormHeader: FC<FormHeaderProps> = ({
  initialData,
  currentLanguage,
  pickLanguage,
  onClose,
  t,
}) => {
  return (
    <div className="bg-gray-50 flex items-center gap-4 p-6 w-full justify-between border-b border-gray-100">
      <div className="w-12">
        <button
          className="tertiary bg-transparent text-gray-400"
          onClick={onClose}
        >
          <XIcon className="w-4 h-4" />
        </button>
      </div>
      <h4 className="grow">
        {t(
          initialData
            ? 'stakeholder.group.update.modal.title'
            : 'stakeholder.group.create.modal.title',
        )}
      </h4>
      <LanguageDropdown
        currentLanguage={currentLanguage}
        onUpdate={pickLanguage}
      />
    </div>
  );
};
